import styles from "./PayGoCodeCard.module.scss";
import { useSinglePaygo } from "../../../hooks/usePaygo";
import { LoaderSreen } from "../../../../../common/components/molecule/Loader/Loader";
import ErrorScreenApp from "../../../../errorHandler/components/ErrorScreenApp/ErrorScreenApp";
import { JWayIcon } from "../../../../../common/assets/JWayIcons";
import { formatString } from "../../../../../utils/string.utils";
import imgBG from "../../../../../assets/coin.png";
import { motion } from "framer-motion";
export const PayGoCodeCardPresenter = ({ payGoId }: { payGoId?: string }) => {
  const {
    singlePaygoQuery: { isLoading, isError, error, data },
  } = useSinglePaygo();

  if (isLoading) {
    return <LoaderSreen heigth={"200px"} />;
  }

  if (isError) {
    return <ErrorScreenApp axiosError={error} />;
  }
  return <PayGoCardView code={data?.paygo_token} kWh={data?.paygo_kwh.toFixed(2) + ""} />;
};

export const PayGoCardView = ({
  code,
  kWh,
}: {
  code?: string;
  kWh?: string;
}) => {
  return (
    <motion.div
      initial={{ transform: "scale(0.7)", opacity: 0 }}
      animate={{ transform: "scale(1)", opacity: 1 }}
      exit={{ transform: "scale(0.7)", opacity: 0}}
      transition={{
        type: "spring",
        duration: 0.3,
        delay: 0.2,
        stiffness: 260,
        damping: 20,
      }}

      className={styles["paygo-code-card"]}
    >
      <img src={imgBG} alt="coin" className={styles["paygo-code-card__bg"]} />
      <div
        className={[styles["paygo-code-card__header"], styles["header"]].join(
          " "
        )}
      >
        <div>
          <JWayIcon type={"coin"} size={20} color="#ffffff66" />
        </div>
        <span className={styles["header__title"]}>PAYGO CODE</span>
      </div>
      <div
        className={[styles["paygo-code-card__body"], styles["body"]].join(" ")}
      >
        <span className={styles["body__code"]}>
          {formatString(code, " - ")}
        </span>
        <div
          className={[
            styles["body__kwh-container"],
            styles["kwh-container"],
          ].join(" ")}
        >
          <p className={styles["kwh-container__kwh"]}>
            <div style={{ marginRight: 10 }}>
              <JWayIcon type={"thunder"} color="#17292f" size={10} />
            </div>
            {kWh}
            <span>kWh</span>
          </p>
        </div>
      </div>
    </motion.div>
  );
};
